/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { memo, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useQuery } from 'react-query';

import { Box, CircularProgress } from '@mui/material';

import { Namespaces } from '../../i18n';
import { SystemConfiguration } from '../../types/superuser/SystemConfiguration';
import { fetchSystemConfiguration } from '../../utils/queryFns';
import { useDocumentTitle } from '../../utils/useDocumentTitle';

export const ImprintPage = memo(() => {
  const { t } = useTranslation(Namespaces.Common);
  useDocumentTitle(t('page_titles.imprint'));
  const systemConfigQuery = useQuery([fetchSystemConfiguration.key], fetchSystemConfiguration.fn);

  const systemConfig = useMemo(
    () => systemConfigQuery.data?.payload ?? ({} as SystemConfiguration),
    [systemConfigQuery.data],
  );

  return (
    <Box display="flex" flexDirection="column" flex={1} justifyContent="center" alignItems="center">
      {systemConfigQuery.isLoading ? (
        <CircularProgress color="primary" />
      ) : (
        <div dangerouslySetInnerHTML={{ __html: systemConfig.imprint }} />
      )}
    </Box>
  );
});
